<template>
  <div class="susceptible-diseases-page">
    <van-nav-bar
      title="易患病症"
      left-arrow
      @click-left="onClickLeft"
      fixed
      placeholder
      safe-area-inset-top
    />

    <div class="teal-bg">
      
      <!-- 解析说明卡片 -->
      <div class="card-container">
        <div class="card-header-center">
          <img src="https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/解析说明.png" alt="解析说明" class="header-icon" />
          <span class="header-title">解析说明</span>
        </div>
        <div class="introduce-text">
          {{ introduce }}
        </div>
      </div>

      <!-- 易患病症列表卡片 -->
      <div class="card-container list-card">
        <div class="card-header-center">
          <img src="https://pro-yeahgo-oss.yeahgo.com/file/zywzimg/易患病症.png" alt="易患病症" class="header-icon" />
          <span class="header-title">易患病症</span>
        </div>

        <div class="list-wrapper">
          <div class="disease-item" v-for="(item, index) in list" :key="index">
            <span class="disease-name">{{ item.name }}</span>
            <span class="disease-risk" :class="getRiskClass(item.risk)">{{ item.risk }}</span>
          </div>
        </div>
      </div>

      <!-- 底部声明与时间 (无白色背景) -->
      <div class="bottom-statement">
        <div class="statement-text">
          重要声明：本报告采用AI人工智能分析总结，仅供参考，不可作为医疗诊断结论，如已有身体不适，请及时咨询医生。
        </div>
        <div class="time-text" v-if="createAt">
          生成时间：{{ formatTime(createAt) }}
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { NavBar, Icon } from 'vant';

export default {
  name: 'MyAiSusceptibleDiseases',
  components: {
    [NavBar.name]: NavBar,
    [Icon.name]: Icon,
  },
  data() {
    return {
      introduce: '',
      list: [],
      createAt: ''
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    loadData() {
      const dataStr = sessionStorage.getItem("MY_AI_PREDISPOSING_DISEASES");
      if (dataStr) {
        try {
          const data = JSON.parse(dataStr);
          this.introduce = data.introduce || '';
          this.list = data.list || [];
          this.createAt = data.createAt || '';
        } catch (e) {
          console.error("解析易患病症数据失败", e);
        }
      }
    },
    getRiskClass(risk) {
      if (!risk) return 'risk-low';
      if (risk.includes('高')) return 'risk-high';
      if (risk.includes('中')) return 'risk-medium';
      return 'risk-low';
    },
    formatTime(timeStr) {
      if (!timeStr) return '';
      try {
        const parts = timeStr.split(' ');
        const dateParts = parts[0].split('-');
        return `${dateParts[0]}年${parseInt(dateParts[1], 10)}月${parseInt(dateParts[2], 10)}日 ${parts[1] || ''}`;
      } catch (e) {
        return timeStr;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.susceptible-diseases-page {
  background: #44C2C4;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.teal-bg {
  flex: 1;
  background: #44C2C4;
  padding: 16px 12px;
}

.card-container {
  background: #fff;
  border-radius: 12px;
  padding: 20px 16px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.05);
  margin-bottom: 16px;
}

.card-header-center {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}

.header-icon {
  width: 30px;
  height: 30px;
  margin-right: 8px;
  object-fit: contain;
}

.header-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
}

/* 解析说明 */
.introduce-text {
  background: #f7f8fa;
  padding: 16px;
  border-radius: 8px;
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  text-align: justify;
}

/* 列表卡片 */
.list-card {
  padding: 20px 12px;
}

.list-wrapper {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.disease-item {
  position: relative;
  background: #f1fafb; /* 非常浅的蓝色背景，类似截图 */
  border-radius: 8px;
  padding: 19px 16px;
  display: flex;
  align-items: center;
  overflow: hidden;
}

.disease-name {
  font-size: 14px;
  font-weight: bold;
  color: #2c7f9a;
}

/* 右上角 Tag */
.disease-risk {
  position: absolute;
  top: 0;
  right: 0;
  color: #fff;
  font-size: 12px;
  padding: 4px 12px;
  border-radius: 0 8px 0 8px; /* 右上、左下圆角 */
  font-weight: 500;
}

/* 风险等级对应的背景色，您可以根据设计图进一步微调颜色 */
.risk-low {
  background: #44C2C4; /* 截图中的深青色 */
}
.risk-medium {
  background: #FFA142; /* 橙色 */
}
.risk-high {
  background: #FF5A5A; /* 红色 */
}

/* 底部声明与时间 (无白色背景) */
.bottom-statement {
  padding: 16px 12px;
  margin-top: 8px;
}

.statement-text {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
  text-align: justify;
}

.time-text {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
  margin-top: 8px;
  text-align: center;
}
</style>
